import { ClientType } from '../apollo'
import { types } from '../types'

import { updateOneSysNotice } from '@dinosband/bv-main-schema/dist/client-gql'

export async function updateSysNotice (client: ClientType, id: number, data: types.SysNoticeUpdateInput): Promise<types.SysNotice | undefined> {
  try {
    const result = await client.mutate({
      mutation: updateOneSysNotice,
      variables: {
        where: { id },
        data,
      },
    })
    return result.data.updateOneSysNotice
  } catch (e) {
  }
}
